import { get_os_name } from '@/utils/utils_app';
import { EOSName } from '@shared/dto/app_info/e_os_name';

export const KeyDescription = {
  AltOrOption: '',

  ArrowUp: '\u2191\uFE0F',
  ArrowDown: '\u2193\uFE0F',
  ArrowLeft: '\u2190\uFE0F',
  ArrowRight: '\u2192\uFE0F',

  Cmd: 'Cmd \u2318', //not a key, just a name of key
};

KeyDescription.AltOrOption = get_os_name() == EOSName.MACOS ? 'Option' : 'Alt';
